import { render } from "./OcrView.vue?vue&type=template&id=7530dfee&scoped=true&ts=true"
import script from "./OcrView.vue?vue&type=script&lang=ts"
export * from "./OcrView.vue?vue&type=script&lang=ts"

import "./OcrView.vue?vue&type=style&index=0&id=7530dfee&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7530dfee"]])

export default __exports__